import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Icon, Modal } from 'components/HeroSemantic';
import renderValidationError from 'utils/renderValidationError';

const Dialog = ({ open, type, title, message, onClose }) => {
  const { formatMessage } = useIntl();
  const resolvedTitle = typeof title === 'string' ? formatMessage({ id: title, defaultMessage: title }) : title;
  const resolvedMessage = typeof message === 'string' ? formatMessage({ id: message, defaultMessage: message }) : message;

  const getType = () => {
    switch (type) {
      case 'error': return { icon: 'exclamation triangle', color: '#db5959', bg: 'rgba(219, 89, 89, 0.12)' };
      case 'warning': return { icon: 'warning circle', color: '#e39f30', bg: 'rgba(227, 159, 48, 0.14)' };
      case 'info': return { icon: 'info circle', color: '#b8875a', bg: 'rgba(184, 135, 90, 0.14)' };
      case 'success': return { icon: 'check circle', color: '#16a34a', bg: 'rgba(22, 163, 74, 0.12)' };
      default: return {};
    }
  };

  const dialogType = getType();
  const dialogMessage = renderValidationError(resolvedMessage);

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Content style={{ padding: '32px 28px 24px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', textAlign: 'center' }}>
          <span
            aria-hidden="true"
            style={{
              alignItems: 'center',
              background: dialogType.bg,
              borderRadius: '999px',
              display: 'inline-flex',
              height: '64px',
              justifyContent: 'center',
              width: '64px',
            }}
          >
            <Icon
              name={dialogType.icon}
              style={{ color: dialogType.color, width: '36px', height: '36px' }}
            />
          </span>
          <h2 style={{ color: 'var(--owner-text)', fontSize: '20px', fontWeight: 600, lineHeight: '28px', margin: 0 }}>
            {resolvedTitle}
          </h2>
          <p style={{ color: 'var(--owner-text-muted)', fontSize: '14px', fontWeight: 400, lineHeight: '20px', margin: 0, maxWidth: '360px', whiteSpace: 'pre-line' }}>
            {dialogMessage}
          </p>
          <Button
            onClick={onClose}
            style={{
              background: dialogType.color,
              border: 'none',
              borderRadius: '10px',
              color: '#ffffff',
              fontSize: '14px',
              fontWeight: 600,
              minHeight: '40px',
              marginTop: '8px',
              padding: '8px 28px',
            }}
          >
            <FormattedMessage id="general.dismiss" />
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};

Dialog.propTypes = {
  open: PropTypes.bool,
  type: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.oneOfType([
    // Mainly for displaying password validation errors.
    PropTypes.shape({
      message: PropTypes.string,
      value: PropTypes.number,
    }),
    // For the rest.
    PropTypes.string,
  ]),
  onClose: PropTypes.func.isRequired,
};

export default Dialog;
